import Directory from './Directory.svg';
import DoorAccess from './Digital Keys.svg';
import EventCalendar from './Calendar.svg';
import EventsSchedule from './Events.svg';
import InteractiveMap from './Interactive Map.svg';
import Messages from './Messages.svg';
import NewsAnnouncements from './News & Announcements.svg';
import BlueDot from './Real-Time Bluedot Wayfinding.svg';
import SocialLinks from './Social Links.svg';
import WebViews from './Resources.svg';

const WorkplaceComponents = { 
    '2': (<img src={Directory} />),
    '3': (<img src={DoorAccess} />),
    '4': (<img src={EventsSchedule} />),
    '5': (<img src={EventCalendar} />),
    '7': (<img src={InteractiveMap} />),
    '8': (<img src={Messages} />),
    '9': (<img src={NewsAnnouncements} />),
    '10': (<img src={BlueDot} />),
    '11': (<img src={WebViews} />),
    '12': (<img src={SocialLinks} />)
}

export default WorkplaceComponents;